import { ReadonlyURLSearchParams } from 'next/navigation'

import { UserInfo } from '@/api/models/auth/lib/auth.types'
import { PERMISSIONS_EXPIRES_AT_UNLIMITED_LABEL } from '@/components/shared/datepicker/model/permissionsExpiresAt'
import { APP_DRAWER_QUERY_KEY, ENTITY_ID_QUERY_KEY } from '@/utils/constants'
import { getMskNow, toMskDay } from '@/utils/datetime'

import { userProfileEntities, userProfilePathnames } from './constants'
import { UserProfileScreens } from './types'

export const NO_DATA_LABEL = '\u2014'

const DISPLAY_DATE_FORMAT = 'D MMMM YYYY'

const DISPLAY_DATE_FORMAT_WITHOUT_YEAR = 'D MMMM'

export const formatMskDate = (value?: string | null) =>
  value ? toMskDay(value).format(DISPLAY_DATE_FORMAT) : NO_DATA_LABEL

const formatMskDateHidingCurrentYear = (value: string) => {
  const day = toMskDay(value)
  const isCurrentYear = day.year() === getMskNow().year()

  return day.format(
    isCurrentYear ? DISPLAY_DATE_FORMAT_WITHOUT_YEAR : DISPLAY_DATE_FORMAT
  )
}

export const formatPermissionsExpiresAt = (
  permissionsExpiresAt?: string | null
) => {
  if (permissionsExpiresAt === undefined) {
    return NO_DATA_LABEL
  }

  return permissionsExpiresAt
    ? formatMskDateHidingCurrentYear(permissionsExpiresAt)
    : PERMISSIONS_EXPIRES_AT_UNLIMITED_LABEL
}

export const getDisplayUserName = (user?: UserInfo) => {
  if (!user) {
    return
  }
  if (!user.name) {
    return user.title
  }
  return user.isLegalEntity ? user.title : user.name
}

export const getProfileRouteBySearchParams = (
  searchParams: ReadonlyURLSearchParams | null
) => {
  const drawerScreen = searchParams?.get(APP_DRAWER_QUERY_KEY) ?? ''
  const entityId = searchParams?.get(ENTITY_ID_QUERY_KEY) ?? ''

  const userProfileScreens: string[] = Object.values(UserProfileScreens)
  const isUserProfileScreen = userProfileScreens.includes(drawerScreen)

  return isUserProfileScreen
    ? {
        screen: drawerScreen,
        ...(entityId && { entityId })
      }
    : null
}

export const getProfileRouteByPathname = (pathname: string) => {
  const [_, profile, nextScreen, entityId] = pathname.split('/')

  const screen = entityId
    ? userProfileEntities[nextScreen]
    : nextScreen || profile

  return {
    screen,
    ...(entityId && { entityId })
  }
}
//TODO: выпилить бы эту функцию и делать все в useUserProfileRoute. оставлена из-за необходимости обработки пути по /profile
export const getNextProfileRouteByPathname = (
  screen?: string,
  entityId?: string
) => {
  if (!screen) {
    return '/'
  }

  const entityIdPath = entityId ? `/${entityId}` : ''

  return userProfilePathnames[screen] + entityIdPath
}
